import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useApi } from "../../../../../hooks/useApi";
import Loader from "../../../../DefaultStyles/Loader";
import { Textarea } from "../../../../Input/Textarea";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import {
  DeleteModalCommonProps,
  DeleteModalLabel,
} from "../CommentModal/CommentDeleteModal";

interface BlackListDeleteModalProps extends DeleteModalCommonProps {
  userId?: number;
}

export default function BlackListDeleteModal({
  userId,
  cancelEvent,
  closeEvent,
}: BlackListDeleteModalProps) {
  const [deleteBtnClick, setDeleteBtnClick] = useState(false);
  const [reason, setReason] = useState("");

  // 블랙리스트 삭제
  const { response, error, loading } = useApi({
    method: "delete",
    url: deleteBtnClick ? `black-list/${userId}` : undefined,
    data: {
      reason,
    },
  });

  console.log(error);

  useEffect(() => {
    if (error) {
      if (error.code === 400) {
        toast.error("블랙리스트 삭제 권한이 없습니다.");
      }
    }
  }, [error]);

  useEffect(() => {
    if (response?.status === 200) {
      if (closeEvent) {
        closeEvent();
        cancelEvent();
      }
      toast.success("블랙리스트에서 삭제되었습니다.", {});
    }
  }, [response]);

  return (
    <DefaultModalLayout
      modalTitle="블랙리스트 삭제"
      isDeleteModal={true}
      isSmallModal={true}
      closeEvent={() => cancelEvent()}
      confirmEvent={() => setDeleteBtnClick(true)}
      type="input"
      confirmDisabled={reason === ""}
    >
      <DeleteModalLabel>삭제 사유</DeleteModalLabel>

      <Textarea
        placeholder="삭제 사유 입력(100글자 이내)"
        onChange={(e) => setReason(e.target.value)}
        value={reason}
      />

      <>{loading && <Loader />}</>
    </DefaultModalLayout>
  );
}
